import { PRODUCT_MAPPINGS_LOADED, PRODUCT_MAPPING_UPDATED } from './productMappingTypes'
import { handleCompanyLoading } from './companyActionCreators'
import api from '../../services/api'
import { addErrorToast } from './companyActionCreators'

export const fetchProductMappings = () => async (dispatch) => {
  dispatch(handleCompanyLoading())

  try {
    const res = await api.get(`/productMapping`)
    const data = await res.json()

    dispatch(productMappingsLoaded(data))
  } catch (e) {
    dispatch(addErrorToast(e))
  }
}

export const productMappingUpdateLoaded = (payload) => {
  return {
    type: PRODUCT_MAPPING_UPDATED,
    payload: payload,
  }
}
export const productMappingsLoaded = (payload) => {
  return {
    type: PRODUCT_MAPPINGS_LOADED,
    payload: payload,
  }
}

export const handleUpdateProductMapping = (product, newvalue) => async (dispatch) => {
  try {
    const res = await api.post(`/productMapping/${product.id}/update`, {
      newValue: newvalue,
    })
    if (res.ok) {
      const data = await res.json()
      dispatch(productMappingUpdateLoaded(data))
    }
  } catch (e) {
    dispatch(addErrorToast(e))
  }
}
